export default __webpack_public_path__ + "static/media/argon-react.994425e5.png";